import { useState, useEffect } from "react";
import httpclient from "../../../../../Utils";
import dayjs from "dayjs";
import {
  buildQueryParams,
  cleanFilterData,
} from "../../../../../Utils/FilterUtils";

export const useBayReport = ({ autoFetch = true, filters = {} } = {}) => {
  const [reportData, setReportData] = useState([]);
  const [bays, setBays] = useState([]);
  const [categories, setCategories] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fieldMappings = {
    bay_code: ["bay_code"],
    category_code: ["category_code"],
    start_date: ["start_date"],
    end_date: ["end_date"],
    group_by: ["group_by"],
    page: ["page"],
    pagination: ["pagination"],
  };

  const valueTransformers = {
    start_date: (value) => (value ? dayjs(value).format("YYYY-MM-DD") : ""),
    end_date: (value) => (value ? dayjs(value).format("YYYY-MM-DD") : ""),
  };

  const fetchReportData = async (filterData = {}) => {
    setLoading(true);
    setError(null);

    const dataWithPagination = { ...filterData, page: 1, pagination: 50 };
    const cleanedData = cleanFilterData(dataWithPagination);
    const queryParams = buildQueryParams(
      cleanedData,
      fieldMappings,
      {},
      valueTransformers
    );
    const url = `/reports/bay-report${queryParams ? `?${queryParams}` : ""}`;

    try {
      const response = await httpclient.get(url);
      if (response.data.status === 200) {
        setReportData(response.data.data || []);
        setBays(response.data.bays || []);
        setCategories(response.data.categories || []);
        setGroups(response.data.groups || []);
      } else {
        setError(response.data.message || "Failed to fetch data");
      }
    } catch (err) {
      setError(err.message || "An error occurred while fetching data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoFetch) {
      fetchReportData();
    }
  }, [autoFetch]);

  return {
    reportData,
    bays,
    categories,
    groups,
    loading,
    error,
    fetchReportData,
  };
};
